// 角色的下拉框
// 全局变量事件类型数据
var logEventType = {

    0x000: {
      label: "用户登录",
      code: 0x000,
      logInfo: "@:operationLog.dict.accountAndName  登录成功!"
    },
    0x001: {
      label: "用户退出",
      code: 0x001,
      logInfo: " @:operationLog.dict.accountAndName 退出系统成功!"
    },


      0xa00: {
        label: "新增代理",
          code: 0xa00,
          logInfo: " 新增 @:operationLog.dict.accountAndName"
      },
      0xa01: {
        label: "编辑代理",
        code: 0xa01,
        logInfo: " 新增 @:operationLog.dict.accountAndName"
      },
      0xa02: {
        label: "删除代理",
        code: 0xa02,
        logInfo: " 删除 @:operationLog.dict.accountAndName"
      },
      0xa03: {
        label: "暂停代理",
        code: 0xa03,
        logInfo: " 暂停 @:operationLog.dict.accountAndName"
      },
      0xa05: {
        label: "恢复代理",
        code: 0xa05,
        logInfo: " 恢复 @:operationLog.dict.accountAndName"
      },
      0xa04: {
        label: "修改代理",
        code: 0xa04,
        logInfo: "修改 @:operationLog.dict.accountAndName"
      },
      0xb00: {
        label: "修改密码",
        code: 0xb00,
        logInfo: "修改 @:operationLog.dict.accountAndName"
      },
      0xb01: {
        label: "密码重置",
        code: 0xb01,
        logInfo: "密码重置 @:operationLog.dict.accountAndName"
      },
      0xb02: {
        label: "修改域名",
        code: 0xb02,
        logInfo: "修改域名 @:operationLog.dict.domain"
      },

      0xc00: {
        label: "新增管理",
          code: 0xc00,
          logInfo: "新增管理 @:operationLog.dict.accountAndName"
      },
      0xc01: {
        label: "修改管理",
        code: 0xc01,
        logInfo: "修改管理 @:operationLog.dict.accountAndName"
      },
      0xc02: {
        label: "删除管理",
        code: 0xc02,
        logInfo: "删除管理 @:operationLog.dict.accountAndName"
      },
      0xc03: {
        label: "暂停管理",
        code: 0xc03,
        logInfo: "暂停管理 @:operationLog.dict.accountAndName"
      },
      0xc04: {
        label: "管理密码重置",
        code: 0xc04,
        logInfo: "管理密码重置 @:operationLog.dict.accountAndName"
      },

      0xc05: {
      label: "恢复管理",
        code: 0xc05,
        logInfo: "恢复管理 @:operationLog.dict.accountAndName"
     },

    //企业部分
    0x04: {
        label: "新增企业",
          code: 0x04,
          logInfo: "新增企业 @:operationLog.dict.accountAndName"
      },
    0x05: {
      label: "删除企业",
      code: 0x05,
      logInfo: "删除企业 @:operationLog.dict.accountAndName"
    },
    0x02: {
      label: "修改企业",
      code: 0x02,
      logInfo: "修改 @:operationLog.dict.accountAndName"
    },
    0x03: {
      label: "暂停企业",
      code: 0x03,
      logInfo: "暂停 @:operationLog.dict.accountAndName"
    },
    0x06: {
      label: "恢复企业",
      code: 0x06,
      logInfo: "恢复企业 @:operationLog.dict.accountAndName"
    },
    //子代理SecMerchant
    0x10: {
      label: "新增子代理",
      code: 0x10,
      logInfo: "新增子代理 @:operationLog.dict.accountAndName"
    },
    0x11: {
      label: "删除子代理",
      code: 0x11,
      logInfo: "删除子代理 @:operationLog.dict.accountAndName"
    },
    0x12: {
      label: "修改子代理",
      code: 0x12,
      logInfo: "修改子代理 @:operationLog.dict.accountAndName"
    },
    0x13: {
      label: "暂停子代理",
      code: 0x13,
      logInfo: "暂停子代理 @:operationLog.dict.accountAndName"
    },
    0x14: {
      label: "子代理密码重置",
      code: 0x14,
      logInfo: "子代理密码重置 @:operationLog.dict.accountAndName"
    },
    0x15: {
      label: "恢复子代理",
      code: 0x15,
      logInfo: "恢复子代理 @:operationLog.dict.accountAndName"
    },
  //用户
  0xd00: {
      label: "（批量）新增用户",
        code: 0xd00,
        logInfo: "（批量）新增用户 @:operationLog.dict.accountAndName"
    },
    0xd01: {
      label: "新增用户",
        code: 0xd01,
        logInfo: "新增终端账号 @:operationLog.dict.accountAndName"
    },
    0xd02: {
      label: "修改用户",
        code: 0xd02,
        logInfo: "修改用户 @:operationLog.dict.accountAndName"
    },
    0xd040: {
      label: "修改账号",
        code: 0xd040,
        logInfo: "修改账号 @:operationLog.dict.accountAndName  新账号{attribute1} 旧账号{attribute2} "
    },
    0xd03: {
      label: "删除用户",
        code: 0xd03,
        logInfo: "删除用户 @:operationLog.dict.accountAndName"
    },

    0xd04: {
      label: "暂停用户",
        code: 0xd04,
        logInfo: "暂停终端账号 @:operationLog.dict.accountAndName"
    },

  //群组
    0xe00: {
      label: "(批量)新增群组",
        code: 0xe00,
      //  logInfo: "(批量)新增群组 @:operationLog.dict.group"
      logInfo: "(批量)新增群组 群组名称：{groupName}"
    },
    0xe01: {
      label: "新增群组",
        code: 0xe01,
       // logInfo: "新增群组 @:operationLog.dict.group"  //originName
      logInfo: "新增群组 群组名称：{groupName}"  //originName
    },
    0xe02: {
      label: "修改群组信息",
        code: 0xe02,
     //   logInfo: "修改群组信息 @:operationLog.dict.group"
      logInfo: "修改群组信息 新群组名称：{groupName},旧群组名称：{originName}"
    },

    0xe03: {
      label: "群组增加成员",
        code: 0xe03,
        logInfo: "群组增加成员 @:operationLog.dict.groupLog"
    },

    0xe07: {
      label: "用户添加群组",
        code: 0xe07,
        logInfo: "用户添加群组 @:operationLog.dict.groupLog"
    },

    0xe04: {
      label: "群组删除成员",
        code: 0xe04,
        logInfo: "群组删除成员 @:operationLog.dict.groupLog"
    },
    0xe05: {
      label: "群组暂停",
        code: 0xe05,
        logInfo: "群组暂停 @:operationLog.dict.group,群组id: {groupId}"
    },

    0xe08: {
      label: "群组启动",
      code: 0xe08,
      logInfo: "群组启动 @:operationLog.dict.group,群组id:{groupId}"
    },

  0xe06: {
      label: "群组删除",
        code: 0xe06,
        logInfo: "群组删除 @:operationLog.dict.group,群组id: {groupId}"
    },
    0xf00: {
      label: "增加好友",
        code: 0xf00,
        logInfo: "增加好友 自己账号:@:operationLog.dict.myAccount,好友账号:@:operationLog.dict.targetAccount,好友名称:@:operationLog.dict.targetName"
    },
    0xf01: {
      label: "删除好友",
        code: 0xf01,
        logInfo: "删除好友 自己账号:@:operationLog.dict.myAccount,好友账号:@:operationLog.dict.targetAccount,好友名称:@:operationLog.dict.targetName"
    },
    0xf02: {
      label: "消息管理",
        code: 0xf02,
        logInfo: "消息管理 @:operationLog.dict.accountAndName"
    },
    0xf03: {
      label: "下发广播",
        code: 0xf03,
        logInfo: "下发广播 @:operationLog.dict.accountAndName"
    },

  //二级管理
    0x21: {
      label: "新增二级管理",
      code: 0x21,
      logInfo: "新增二级管理 @:operationLog.dict.accountAndName"
    },
    0x22: {
      label: "二级管理修改",
      code: 0x22,
      logInfo: "二级管理修改 @:operationLog.dict.accountAndName"
    },
    0x23: {
      label: "二级管理删除",
      code: 0x23,
      logInfo: "二级管理删除 @:operationLog.dict.accountAndName"
    },
    0x24: {
      label: "暂停二级管理",
      code: 0x24,
      logInfo: "暂停二级管理 @:operationLog.dict.accountAndName"
    },

    0xf08: {
      label: "恢复二级管理",
      code: 0xf08,
      logInfo: "恢复二级管理 @:operationLog.dict.accountAndName"
    },

    0x25: {
      label: "二级管理密码重置",
      code: 0x25,
      logInfo: "二级管理密码重置 @:operationLog.dict.accountAndName"
    },
    0x026: {
      label: "账号转移",
      code: 0x026,
      logInfo: "操作人账号:{operatorAccount} 将  终端 账号:{terminalAccount}  从 @:qbLog.dict.originRole 账号:{originAccount}  移动到 @:qbLog.dict.targetRole 账号:{targetAccount}  "
    },
    0x027: {
      label: "终止用户",
      code: 0x027,
      logInfo: "操作人账号:{operatorAccount}  终止   @:qbLog.dict.originRole 账号:{originAccount} 的 @:qbLog.dict.targetRole  账号:{targetAccount}  "
    },
    0x028: {
      label: "恢复用户",
      code: 0x028,
      logInfo: "操作人账号:{operatorAccount}  恢复   @:qbLog.dict.targetRole  账号:{targetAccount}  到  @:qbLog.dict.originRole 账号:{originAccount}  "
    },
    0x029: {
        label: "恢复会计",
        code: 0x029,
        logInfo: "恢复会计 @:operationLog.dict.accountAndName"
      },
    0x030: {
      label: "暂停会计",
      code: 0x030,
      logInfo: "暂停会计 @:operationLog.dict.accountAndName"
    },
    0x031: {
      label: "暂停域名",
      code: 0x031,
      logInfo: "暂停域名 @:operationLog.dict.accountAndName"
    },
    0x032: {
      label: "恢复域名",
      code: 0x032,
      logInfo: "恢复域名 @:operationLog.dict.accountAndName"
    },



    0x033: {
    label: "确定终身绑定",
      code: 0x033,
      logInfo: "确定终身绑定 域名： {targetName} 域名id: {targetAccount} "
    },
    0x034: {
      label: "解除终身绑定",
        code: 0x034,
        logInfo: "解除终身绑定  域名： {targetName} 域名id: {targetAccount}"
    },
    0x035: {
      label: "机型绑定",
        code: 0x035,
        logInfo: "机型绑定  域名：{targetName} 机器id: {targetAccount}"
    },

    0x036: {
      label: "机型移除",
        code: 0x036,
        logInfo: "机型移除 域名：{targetName} 机器id: {targetAccount}"
    },


    0x037: {
      label: "删除imei",
        code: 0x037,
        logInfo: "删除imei  账号：{targetAccount} imei: {targetName}"
    },

    0x038: {
      label: "imei区间新增",
      code: 0x038,
      logInfo: "imei区间新增  账号：{targetAccount} 起始信息: {targetName}"
    },


    0x039: {
      label: "imei批量新增",
        code: 0x039,
        logInfo: "imei批量新增  账号：{targetAccount} imei信息: {targetName}"
    },

     0xf04:{
        label: "增加iccid",
          code: 0xf04,
          logInfo:" 新增iccid:  {targetName}   目标账号: {originAccount}"
      },
      0xf06:{
        label: "批量增加iccid",
        code: 0xf06,
        logInfo:"批量新增iccid:  {targetName}   目标账号: {originAccount}"
      },
      0xf07:{
        label: "区间增加iccid",
        code: 0xf07,
        logInfo:"区间新增iccid: {targetName}   目标账号: {originAccount}"
      },
      0xf05:{
        label: "回收iccid",
        code: 0xf05,
        logInfo:"回收iccid: {originName} 目标账号: {originAccount}"
      },
      0x50: {
        label: "创建监听",
        code: 0x50,
        logInfo: "监听组名称和id:{originName},{originId} 终端账号:{originAccount}"
      },

      0x51: {
        label: "删除监听",
        code: 0x51,
        logInfo: "删除监听组:{originName},{originId} 终端账号:{originAccount}"
      },

      0x52: {
        label: "专网绑定",
        code: 0x52,
        logInfo: "绑定专网数据:{originName},绑定id: {originId} 绑定账号:{originAccount}"
      },

      0x53: {
        label: "专网解除",
        code: 0x53,
        logInfo: "解除专网数据:{originName},解除id: {originId} 解除账号:{originAccount}"
      },

      0x54: {
        label: "组织转移",
        code: 0x54,
        logInfo: "组织转移:用户:{originAccount},{originName} 从{originId}级,{targetAccount}, 转移到：{targetId}级,{targetName}"
      },

  //CREATE_RADIP(0x55,"创建广播"),
      0x55: {
        label: "创建广播",
          code: 0x55,
          logInfo: "创建人:{originName},{originAccount} 广播名称:{targetName}"
      },
      0x56: {
        label: "创建组织",
        code: 0x56,
        logInfo: "创建人:{originName},{originAccount} 组织账号/名称/层级:{targetAccount} 所选用户:{targetName}"
      },
      0x57: {
        label: "删除组织",
        code: 0x57,
        logInfo: "删除人:{originName},{originAccount} 组织信息:{targetAccount}"
      },

      0x58: {
        label: "批量用户绑订单",
        code: 0x58,
        logInfo: "批量新增用户绑定订单，用户账号:{originAccount} ,订单号:{originName}"
      },

      0x59: {
        label: "批量用户划分Q币",
        code: 0x59,
        logInfo: "批量用户划分Q币，用户账号:{originAccount} ,Q币数:{originName}"
      },

      0x60: {
        label: "（批量）用户修改功能",
        code: 0x60,
        logInfo: "（批量）用户修改功能，用户账号:{originAccount} ,{originName}"
      },

      0x61: {
        label: "（批量）用户设置二级管理",
        code: 0x61,
        logInfo: "（批量）用户设置二级管理，用户账号:{originAccount} ,二级名称:{originName}"
      },

};


let admin =  [
  logEventType[0x000],  //用户登录
  // logEventType[0x001],  //用户登出
  logEventType[0xa00],  //新增代理
  // logEventType[0xa01],  //编辑代理
  logEventType[0xa02],  //删除代理
  logEventType[0xa03],  //暂停代理
  logEventType[0xa04],  //修改代理
  //  logEventType[0xb00],  //修改密码
  logEventType[0xb01],  //密码重置
  logEventType[0xb02],  //修改域名
  logEventType[0xc00],  //新增管理
  logEventType[0xc01],  //修改管理
  logEventType[0xc02],  //删除管理
  logEventType[0xc03],  //暂停管理
  logEventType[0xc05],  //恢复管理
  logEventType[0xf03], //下发广播
  logEventType[0x026], //账号转移
  logEventType[0x027], //终止终端
  logEventType[0x028], //恢复终端
  logEventType[0x029], //恢复会计
  logEventType[0x030], //暂停会计
  logEventType[0x031], //暂停域名
  logEventType[0x032], //恢复域名
  logEventType[0xf04], //新增iccid
  logEventType[0xf05], //回收iccid
  logEventType[0xf06], //批量新增iccid
  logEventType[0xf07], //区间新增iccid
  logEventType[0x033],//确定终身绑定
  logEventType[0x034],//解除终身绑定
  logEventType[0x035],//机型绑定
  logEventType[0x036],//移除机型
  logEventType[0x037],//删除imei
  logEventType[0x038],//imei批量新增
  logEventType[0x039],//imei新增
  logEventType[0x53],//专网解除
];

let proxy =[
  logEventType[0x000],
  // logEventType[0x001],
  logEventType[0x04], //新增企业
  logEventType[0x05], //删除企业
  logEventType[0x02], //修改企业
  logEventType[0x03], //暂停企业
  // logEventType[0xb00],  //修改密码
  logEventType[0xb01], //密码重置
  logEventType[0x10], //新增子代理
  logEventType[0x11], //删除子代理
  logEventType[0x12], //修改子代理
  logEventType[0x13], //暂停子代理
  logEventType[0xc00],  //新增管理
  logEventType[0xc01],  //修改管理
  logEventType[0xc02],  //删除管理
  logEventType[0xc03],  //暂停管理
  logEventType[0xc05],  //恢复管理
  logEventType[0x14], //子代理密码重置
  logEventType[0xc04],  //管理密码重置
  logEventType[0x026], //账号转移
  logEventType[0x027], //终止终端
  logEventType[0x028], //恢复终端
];

let subagent =[
  logEventType[0x000],
  // logEventType[0x001],
  logEventType[0x04], //新增企业
  logEventType[0x05], //删除企业
  logEventType[0x02], //修改企业
  logEventType[0x03], //暂停企业
  // logEventType[0xb00],  //修改密码
  logEventType[0xb01], //密码重置
  logEventType[0xc00],  //新增管理
  logEventType[0xc01],  //修改管理
  logEventType[0xc02],  //删除管理
  logEventType[0xc03],  //暂停管理
  logEventType[0xc05],  //恢复管理
  logEventType[0xc04],  //管理密码重置
  logEventType[0x026], //账号转移
  logEventType[0x027], //终止终端
  logEventType[0x028], //恢复终端
];

let enterprise = [
  logEventType[0x000],
  // logEventType[0x001],
  logEventType[0xd01], //新增用户
  logEventType[0xd02], //修改用户
  logEventType[0xd040], //修改账号
  logEventType[0xd00], //批量新增用户
  // logEventType[0xd03], //删除用户0xd04
  //logEventType[0xd04], //暂停用户
  logEventType[0xe01], //新增群组
  logEventType[0xe00], //批量新增群组
  logEventType[0xe02], //修改群组信息
  logEventType[0xe03], //群组增加成员
  logEventType[0xe07], //用户添加群组
  logEventType[0xe04], //群组删除成员
  logEventType[0xe05], //群组暂停
  logEventType[0xe08], //群组启用
  logEventType[0xe06], //群组删除
  logEventType[0xf00], //增加好友
  logEventType[0xf01], //删除好友
  logEventType[0xf02], //消息管理
  logEventType[0xf03], //下发广播
  logEventType[0x21],  //新增二级管理
  logEventType[0x22],  //修改二级管理
  logEventType[0x23],  //删除二级管理
  logEventType[0x24],  //暂停二级管理
  logEventType[0xf08],  //恢复二级管理
  logEventType[0x25],  //二级管理密码重置
  logEventType[0xc00],  //新增管理
  logEventType[0xc01],  //修改管理
  logEventType[0xc02],  //删除管理
  logEventType[0xc03],  //暂停管理
  logEventType[0xc05],  //恢复管理
  logEventType[0x026],  //账号转移
  logEventType[0x027],  //暂停终端
  logEventType[0x028],  //恢复终端
  logEventType[0xf04], //新增iccid
  logEventType[0xf05], //回收iccid
  logEventType[0xf06], //批量新增iccid
  logEventType[0xf07], //区间新增iccid
  logEventType[0x52],  //专网绑定
  logEventType[0x53],  //专网解除
  logEventType[0x54],  //组织转移
  logEventType[0x50],  //添加监听
  logEventType[0x51],  //删除监听
  logEventType[0x55],  //删除监听
  logEventType[0x56],  //添加组织
  logEventType[0x57],  //删除组织
  logEventType[0x58],//批量新增用户绑定订单
  logEventType[0x59],//批量用户划分Q币
  logEventType[0x60],
  logEventType[0x61],
];

//角色下拉框
let roleLogOption = {
  1:admin,
  5:admin,
  6:admin,
  2:proxy,
  8:proxy,
  9:proxy,

  3:subagent,
  10:subagent,
  11:subagent,

  4: enterprise,
  12: [
    logEventType[0x000],

  ],
  13: enterprise,
  14: [
    logEventType[0x000],
    // logEventType[0x001],
    logEventType[0xd02], //修改用户
    logEventType[0xd040], //修改账号
    // logEventType[0xd03], //删除用户0xd04
    //logEventType[0xd04], //暂停用户
    logEventType[0xe01], //新增群组
    logEventType[0xe02], //修改群组信息
    logEventType[0xe03], //群组增加成员
    logEventType[0xe04], //群组删除成员
    logEventType[0xe05], //群组暂停
    logEventType[0xe06], //群组删除
    logEventType[0x027], //终止终端


  ]

};

const operationLog = {
  //数据字典
  dict: {
    role: "{originRole,select,1{总代理} 2{代理} 3{子代理} 4{企业}   other{ } 5{总代代理管理} 6{总代代理信息} 7{用户} 8{代理的企业管理} 9{代理的信息管理} " +
    "10{子代理信息查询} 11{子代理企业管理} 12{企业的信息查询} 13{企业的用户管理} 14{二级企业} 15{二级企业的信息查询 } 16{会计} 17{子代理新增的企业} 20{群组} } ",
    accountAndName: " @:operationLog.dict.role账号:{originAccount} , @:operationLog.dict.role名称:{originName}",
    groupLog: " 群组Id：{groupId}，群组名称:{groupName}，终端账号:{terminalAccount}。",
    domain:" @:operationLog.dict.role账号:{originAccount} , @:operationLog.dict.role名称:{originName} 旧域名{attribute1} 新域名{attribute2}",
    group:"群组名称:{groupName}",
    operatorRoless: "@:operationLog.dict.role:{operatorRole}",
    targetAccount:"{targetAccount}",
    targetId:"{targetId}",
    myAccount:"{originAccount}",
    targetName:"{targetName}",
    originId:"{originId}",

  },
  roleLogOption,
  logEventType
};


export default operationLog;



// WEBPACK FOOTER //
// ./src/api/lang/modules/oplog/operationLog_zh.js